import { render, staticRenderFns } from "./DeliveryMethod.vue?vue&type=template&id=f4761fca&"
import script from "./DeliveryMethod.vue?vue&type=script&lang=ts&"
export * from "./DeliveryMethod.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryMethod.vue?vue&type=style&index=0&id=f4761fca&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports